const contactModalOpen = () => {
  const div_open = document.getElementById('contactModalOpen')
  if (div_open) {
    $('#contactModal').modal('show')
  }
}

export { contactModalOpen }